import { render, staticRenderFns } from "./DistrictReference.vue?vue&type=template&id=4d75f6c6"
import script from "./DistrictReference.vue?vue&type=script&lang=js"
export * from "./DistrictReference.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports